import { IUIRuntime } from '@cian/mf-registry/browser';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import {
  fetchGetModerationComplainMicrofrontend,
  TGetModerationComplainMicrofrontendResponse,
} from '../../repositories/moderation-complain-frontend';
import { IApplicationContext } from '../../types/applicationContext';

export type TGetModerationComplainMicrofrontendResult = {
  manifest: IMicrofrontendManifest;
} | null;

export async function getModerationComplainMicrofrontend(
  context: IApplicationContext,
): Promise<TGetModerationComplainMicrofrontendResult> {
  const { httpApi, logger, microfrontendsRegistry } = context;

  try {
    const data: TGetModerationComplainMicrofrontendResponse = await fetchGetModerationComplainMicrofrontend({
      httpApi,
      parameters: {},
    });

    const image = microfrontendsRegistry.register(data.response.manifest);

    if (typeof window !== 'undefined') {
      const runtime = image.runtimeStrict<IUIRuntime>(data.response.manifest.runtimeName);
      await runtime.ensure();
    }

    return {
      manifest: data.response.manifest,
    };
  } catch (ex) {
    logger.error(ex, { domain: 'shared.services.getModerationComplainMicrofrontend' });

    return null;
  }
}
